import ErrorHandler from '@/ErrorHandler';
import API from '@/org-app/api';
import { createGetAllAction } from '@/utils/ActionsUtils';
import i18n from '@/vueI18n';

import * as types from './mutation-types';

const actions = {
  getAdvancedReportExecutions: createGetAllAction(
    API.instance.getAdvancedReportExecutions,
    types.UPDATE_ADVANCEDREPORTEXECUTION_LIST,
    'messages.failedToGetReportExecution',
    false,
  ),

  async getAdvancedReportExecution({ commit }, id) {
    return API.instance.getAdvancedReportExecution(id).catch((err) => {
      const msg = i18n.global.t('messages.failedToGetUnitRatioStatuses');
      ErrorHandler.showError(msg, err);
      throw err;
    });
  },

  async generateAdvancedReportExecution({ commit }, params) {
    return API.instance.generateAdvancedReportExecution(params).catch((err) => {
      const msg = i18n.global.t('messages.failedToGetReportExecution');
      ErrorHandler.showError(msg, err);
      throw err;
    });
  },
};

export default actions;
